import React from 'react';
import PropTypes from 'prop-types';

export const IconClock = ({ className, active }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" className={className}>
    <path fill={active ? 'url(#icon-clock-active)' : 'url(#icon-clock)'} className="icon-filled-path" fillRule="nonzero" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 0 0-8 8 8 8 0 0 0 8 8 8 8 0 0 0 8-8 8 8 0 0 0-8-8zm0 3a1 1 0 0 1 1 1v3.586l2.707 2.707a1 1 0 0 1-1.414 1.414l-3-3A1 1 0 0 1 11 12V8a1 1 0 0 1 1-1z" />
  </svg>
);

IconClock.propTypes = {
  className: PropTypes.string,
  active: PropTypes.bool,
};
IconClock.defaultProps = {
  className: '',
  active: false,
};
